module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/bg-rsv-today-eb17ee7d1679607310ffd033e50c2b88.svg";